import React from 'react';
import '../style/footer.css';

function Footer() {
    return (
        <div className="footer">
            <p className="footer-text">网站地图&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系我们</p>
            <p className="footer-text">版权所有@三亚市育才生态区管理委员会</p>
            <p className="footer-text">主办: 三亚市育才生态区管理委员会发展和改革局</p>
            <p className="footer-text">
                ICP备案编号: <a href="https://beian.miit.gov.cn" target="_blank">琼ICP备2023012010号-1</a>&nbsp;&nbsp;&nbsp;
                <span className="footer-text__jh"></span><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=46020402000159" target="_blank">琼公网安备 46020402000159号</a>
            </p>
        </div>
    );
}

export default Footer;